import { cn } from '@/lib/utils'

interface StatusBadgeProps {
  status: string
}

const statusConfig: Record<string, { label: string; className: string }> = {
  pending: {
    label: 'En attente',
    className: 'bg-amber-100 text-amber-800 border border-amber-200',
  },
  approved: {
    label: 'Approuvé',
    className: 'bg-blue-100 text-blue-800 border border-blue-200',
  },
  running: {
    label: 'En cours',
    className: 'bg-purple-100 text-purple-800 border border-purple-200',
  },
  completed: {
    label: 'Terminé',
    className: 'bg-green-100 text-green-800 border border-green-200',
  },
  failed: {
    label: 'Échoué',
    className: 'bg-red-100 text-red-800 border border-red-200',
  },
  deleting: {
    label: 'Suppression...',
    className: 'bg-orange-100 text-orange-800 border border-orange-200 animate-pulse',
  },
  delete_failed: {
    label: 'Échec suppression',
    className: 'bg-red-100 text-red-800 border border-red-200',
  },
}

export function StatusBadge({ status }: StatusBadgeProps) {
  const config = statusConfig[status] || {
    label: status,
    className: 'bg-gray-100 text-gray-800 border border-gray-200',
  }

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-3 py-1 text-xs font-medium',
        config.className
      )}
    >
      {config.label}
    </span>
  )
}
